<template>
	<div class="game-video" v-if="videoId">
		<div class="game-video__container">
			<iframe class="game-video__iframe wistia_embed" :src="`//fast.wistia.net/embed/iframe/${videoId}?videoFoam=true&autoPlay=${autoPlay !== false ? 'true' : 'false'}`" allowtransparency="true" frameborder="0" scrolling="no" name="wistia_embed" allowfullscreen mozallowfullscreen webkitallowfullscreen oallowfullscreen msallowfullscreen></iframe>
		</div>
	</div>
</template>

<script>

export default {
	name: 'GameVideo',
	components: {
	},
	data () {
		return {
		}
	},
	props: {
		videoId: String,
		autoPlay: {
			type: Boolean,
			defaul: true,
		},
	},
	computed: {
	},
	created: function()
	{
	},
	mounted: function()
	{
	},
	methods: {
	}
}
</script>

<style lang="scss">
	@import "src/scss/toolkit";

	$c: ".game-video";
	#{$c}
	{
		width: 992px;
		max-width: 100%;
		padding: rem(16);
		background-color: palette(white);
		box-shadow: 0 1px 4px rgba(0,0,0,0.13);

		&__container
		{
			position: relative;
			// display: flex;
			// flex-wrap: nowrap;
			// align-items: center;
			// justify-content: center;

			&:before
			{
				content: "";
				display: block;
				width: 0;
				padding-top: 100% * (9/16);
			}
		}

		&__iframe
		{
			@include extend(absolute-fill);
			border: 0;
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/molecules/GameVideo.vue